import { Accordion } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'

const faqData = [
  {
    question: '优查查是做什么的？',
    answer:
      '优查查是一个个人与企业信息查询平台。在获得用户明确授权的前提下，平台向第三方机构请求相关信息，并将查询结果进行整理与展示，帮助用户查看信息内容本身。',
  },
  {
    question: '优查查会对信息做分析或判断吗？',
    answer: '不会。平台仅负责信息的查询、整理与展示，不对信息进行任何判断、评估或结论性分析。',
  },
  {
    question: '这些信息是从哪里来的？',
    answer:
      '在获得用户明确授权的前提下，平台向第三方机构请求相关信息；同时，部分信息来源于用户自行提供或依法公开可查的渠道。平台仅对获取的信息进行展示与整理。',
  },
  {
    question: '使用优查查是否涉及金融、借贷或投资？',
    answer: '不涉及。优查查不提供任何金融、借贷、投资、信用或风险评估相关服务，也不参与任何交易或撮合行为。',
  },
  {
    question: '平台会不会给出建议，告诉我该怎么做？',
    answer: '不会。平台仅展示信息内容，信息的理解与使用由查看信息的用户自行决定。',
  },
  {
    question: '查询结果会被平台保存吗？',
    answer:
      '为完成用户已付费的信息展示服务，在用户授权前提下，查询结果将被有限期保存，最长不超过 30 天，仅供用户本人或其授权对象查看。服务期结束后，相关内容将自动清除。',
  },
  {
    question: '平台会不会分析或利用这些数据？',
    answer: '不会。平台不对查询结果或用户行为进行分析、画像、推荐或任何其他用途的利用。',
  },
  {
    question: '除了我本人，还有谁可以查看查询结果？',
    answer: '仅限用户本人，或用户明确授权的对象查看。平台工作人员无法随意调取或查看查询结果。',
  },
  {
    question: '平台是否会向第三方提供或出售数据？',
    answer: '不会。平台不会向任何第三方提供、出售或共享用户的查询结果数据。',
  },
  {
    question: '如果我根据查询信息产生纠纷，平台是否负责？',
    answer: '平台仅提供信息查询与展示服务，不对信息的使用结果或由此产生的任何行为承担责任。',
  },
]

export default function FAQSection() {
  return (
    <section className="bg-gray-50 py-12">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-8">
              <span className="text-xs font-medium text-orange-500 uppercase tracking-wider">FAQ</span>
              <h2 className="text-2xl font-bold text-gray-900 mt-2 mb-4">常见问题</h2>
              <p className="text-sm text-gray-500">如果您有其他问题，欢迎联系我们的客服团队</p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              chevron={<IconPlus size={16} />}
              styles={{
                chevron: {
                  '&[data-rotate]': {
                    transform: 'rotate(45deg)',
                  },
                },
              }}
            >
              {faqData.map((item, index) => (
                <Accordion.Item
                  key={index}
                  value={`faq-${index}`}
                  className="bg-white mb-2 rounded-xl border border-gray-100 overflow-hidden"
                >
                  <Accordion.Control className="hover:bg-gray-50">
                    <span className="text-sm font-medium text-gray-900">{item.question}</span>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <span className="text-sm text-gray-600 leading-relaxed">{item.answer}</span>
                  </Accordion.Panel>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  )
}
